import React from 'react';

/**
 * An uploaded image (contract v1.2 §3.13.2 media object): WebP at 800 and
 * 1600 px with a JPEG fallback for browsers without WebP. The alt text lives
 * on the asset, so callers don't pass one.
 *
 * URLs are used exactly as the API gives them (root-relative or absolute CDN
 * URLs); never build one.
 *
 * @param {object} props
 * @param {object} props.media - Media object with kind 'image'
 * @param {string} [props.sizes] - The rendered width, for picking a variant
 * @param {string} [props.className]
 * @param {'lazy'|'eager'} [props.loading]
 */
export default function MediaImage({ media, sizes = '(max-width: 800px) 100vw, 800px', className, loading = 'lazy' }) {
  if (!media || media.kind !== 'image' || !media.variants) {
    return null;
  }
  const { variants } = media;
  return (
    <picture>
      <source type="image/webp" srcSet={`${variants['800']} 800w, ${variants['1600']} 1600w`} sizes={sizes} />
      <img
        src={variants.fallback}
        alt={media.alt || ''}
        width={media.width || undefined}
        height={media.height || undefined}
        loading={loading}
        decoding="async"
        className={className}
      />
    </picture>
  );
}
